import log from 'loglevel';
import pushGTMEvent from '../../util/helper/pushGTMEvent';
import rules from '../../Action/validations/index';

const configContents = ({
  state: {
    langStrings,
    hasError: { fName, lName, newCMEmail },
    newCmDetails
  },
  dispatch,
}) => {

  return [
    {
      isTitle: true,
      description: langStrings
        ? langStrings.cm.processInfoScreen.pageTitle2
        : '3. New information',
        id: 'adsk-page-title',
    },
    {
      description: langStrings
      ? langStrings.cm.processInfoScreen.newCmNameLabel
      : 'New contract manager’s name',
      style: { fontWeight: 600 },
      paragraphStyle: { marginBottom: '5px' },
      endWithRedStar: true,
    },
    {
      isShown: fName, // Error message: firstName.
      description: langStrings
        ? langStrings.errors.enterFirstName
        : 'Enter your first name',
      style: { fontWeight: 400, color: '#ec4a41', fontSize: '14px' },
      paragraphStyle: { marginBottom: '5px' },
      id: 'adsktm-new-cm-fname-error',
    },
    {
      isTextInput: true,
      description: langStrings
        ? langStrings.cm.processInfoScreen.newCmNameLabel
        : 'New contract manager’s name',
      style: { fontWeight: 600 },
      paragraphStyle: { marginBottom: '0px' },
      placeholder: langStrings
      ? langStrings.contactInfoScreen.firstNamePlaceholder
      : 'First name',
      isError: fName,
      value: newCmDetails.firstName,
      handleChange: () => {},
      handleSubmit: () => {},
      handleValidation: (value) => {
        if (value.length <= 0) {
          log.debug('dispatching false');
          dispatch({
            type: 'VALIDATE_NEW_CM_FIRST_NAME',
            payload: true, // convert hasError.fName = true.
          });
        } else {
          // store CM first name if its valid.
          // keep hasError to false state if user entered valid value second time.
          dispatch({
            type: 'NEW_CM_FIRST_NAME',
            payload: {
              firstName: value,
              hasError: false,
            },
          });
        }
      },
      id: 'adsktm-new-cm-fname',
      focusIn: true,
    },
    {
      isShown: lName, // Error message: firstName..
      description: langStrings
        ? langStrings.errors.enterLastName
        : 'Enter your last name',
      style: { fontWeight: 400, color: '#ec4a41', fontSize: '14px' },
      paragraphStyle: { marginBottom: '5px' },
      id: 'adsktm-new-cm-lname-error',
    },
    {
      isTextInput: true,
      description: langStrings
        ? langStrings.cm.processInfoScreen.newCmNameLabel
        : 'New contract manager’s name',
      style: { fontWeight: 600 },
      paragraphStyle: { marginBottom: '20px' },
      placeholder: langStrings
      ? langStrings.contactInfoScreen.lastNamePlaceholder
      : 'Last name',
      handleChange: e => {},
      handleSubmit: () => {},
      handleValidation: value => {
        if (value.length <= 0) {
          dispatch({
            type: 'VALIDATE_NEW_CM_LAST_NAME',
            payload: true,
          });
        } else {
          // store CM last name if its valid.
          // keep hasError to false state if user entered valid value second time.
          dispatch({
            type: 'NEW_CM_LAST_NAME',
            payload: {
              lastName: value,
              hasError: false,
            },
          });
        }
      },
      value: newCmDetails.lastName,
      id: 'adsktm-new-cm-lname',
    },
    {
      description: langStrings // New CM AuthEmail Label.
      ? langStrings.cm.processInfoScreen.newCmEmailLabel
      : 'New contract manager’s email',
      style: { fontWeight: 600 },
      paragraphStyle: { marginBottom: '5px' },
      endWithRedStar: true,
      id: 'adsktm-new-cm-authemail-label',
    },
    {
      isShown: newCMEmail, // Error message: New CM AuthEmail.
      description: langStrings
        ? langStrings.errors.enterValidFormat
        : 'Enter a valid format',
      style: { fontWeight: 400, color: '#ec4a41', fontSize: '14px' },
      paragraphStyle: { marginBottom: '5px' },
      id: 'adsktm-new-cm-authemail-error',
    },
    {
      isTextInput: true,
      placeholder: langStrings
      ? langStrings.contactInfoScreen.emailTitle
      : 'Email',
      handleChange: e => {},
      handleSubmit: () => {},
      handleValidation: val => {
        // convert into lower case
        const trimedValue = val.trim();
        const value = trimedValue.toLowerCase();
        const regex = rules.authEmail.pattern;
        if (value.match(regex)) {
          // store CM auth email if its valid.
          // keep hasError to false state if user entered valid value second time.
          dispatch({
            type: 'NEW_CM_AUTH_EMAIL',
            payload: {
              email: value,
              hasError: false,
            },
          });
        } else {
          // keep hasError to true state.
          dispatch({
            type: 'VALIDATE_NEW_CM_AUTH_EMAIL',
            payload: true,
          });
        }
      },
      value: newCmDetails.email,
      id: 'adsktm-new-cm-auth-email',
      style: { fontWeight: 600 },
      paragraphStyle: { marginBottom: '20px' },
    },
    {
      description: langStrings
      ? langStrings.cm.processInfoScreen.newCmPhoneLabel
      : 'New contract manager’s phone number',
      style: { fontWeight: 600 },
      paragraphStyle: { marginBottom: '5px' },
      id: 'adsktm-new-cm-phone-label',
    },
    {
      isTextInput: true,
      style: { fontWeight: 600 },
      paragraphStyle: { marginBottom: '8px' },
      placeholder: langStrings
      ? langStrings.cm.processInfoScreen.phoneNumPlaceholder
      : 'Include area code and number',
      handleChange: e => {},
      handleSubmit: () => {},
      handleValidation: value => {
        // No validations on Phone field.
        dispatch({
          type: 'NEW_CM_PHONE',
          payload: value,
        });
      },
      value: newCmDetails.phone,
      id: 'adsktm-new-cm-phone',
    },
  ];
};

const configFooter = ({
  state: {
    langStrings,
    hasExtension,
    newCmDetails,
  },
  dispatch,
}) => ({
  requiredDisclaimer: true,
  hasQuestion: true,
  hasExtension,
  nextButtonContent: langStrings ? langStrings.buttons.nextButton : 'NEXT',
  handleNext: () => {
    pushGTMEvent('Authorization');
    dispatch({ type: 'GO_TO_AUTHORIZE_PAGE' })
  },
  handleBack: () => {
    pushGTMEvent('ProductInfo');
    dispatch({ type: 'GO_TO_CM_VALIDATION_PAGE' })
  },
  handleExtension: () => dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' }),
  handleAgentLoad: () => dispatch({ type: 'AGENT_LOADED' }),
  handleAgentAvailable: (flag) => dispatch({ type: 'AGENT_AVALIABLE', payload: { isAgentAvailable: flag } }),
  handleChatInitialized: () => dispatch({ type: 'AGENT_INITIALIZED' }),
  handleChatStarted: () => dispatch({ type: 'GO_TO_AGENT_AVAILABLE_PAGE' }),
  handleSupportAnalytics: () => pushGTMEvent('ContactSupport'),
  handleAgentAnalytics: () => pushGTMEvent('ChatWithAgent'),
  handleCaseAnalytics: () => pushGTMEvent('CreateCase'),
  handleNextButtonId: 'adsktm-cm-next-button',
  handleBackButtonId: 'adsktm-cm-back-button',
  requiredDisclaimerId: 'adsktm-required-disclaimer-text',
  handleAgentButtonId: 'adsktm-agent-button',
  handleCaseButtonId: 'adsktm-case-button',
  handleQuestionButtonId: 'adsktm-have-question-button',
  enableNextButton: (
    newCmDetails.firstName &&
    newCmDetails.lastName &&
    newCmDetails.email
    // eslint-disable-next-line no-unneeded-ternary
    ) ? true : false,
});

export default {
  configContents,
  configFooter,
};
